import {useState, React, useEffect} from "react";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
import {
  Link,
  Box,
  Grid,
  Typography,
  IconButton,
  InputAdornment,   Container,
  Button,
  TextField,
  CircularProgress,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import OtpVerify from "../components/LoginComponents/OtpVerify";
import { successNote, toastErrorNotify } from "../helpers/toastNotify";
import Loading from "../layout/Loading";
import Copyright from "../components/LoginComponents/Copyright";
import * as Yup from "yup";
import { usePostOtpMutation } from "../services/auth/login";
import apiClient from "../api/apiClient";
import { MvAdminAuthorizeUrl } from "../api/endpoints";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [otpMenu, setOtpMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const [entraRedirecting, setEntraRedirecting] = useState(false);
  const [postOtp,] = usePostOtpMutation();

  // Set this to True to enable the default log in page.
  const siteOpen = true;
  
  const yupErrors = {};
  const [validationErrors, setValidationErrors] = useState({});

  const logoRed =  'https://res.cloudinary.com/dge9ers9x/image/upload/v1693381822/Making%20View%20Assets/MV_logo_red_black_ctm6tn.png'
  const authBackgroundImage = 'https://res.cloudinary.com/dge9ers9x/image/upload/v1693381778/Making%20View%20Assets/auth_background_texcon.jpg'

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("A valid email is required")
      .required("A valid email is required"),
    password1: Yup.string()
      .required("Password is required")
  });

  const [values, setValues] = useState({
    password1: "",
    showPassword1: false,
  });

  useEffect(() => {
    const reason = sessionStorage.getItem('logout_reason');
    console.log(reason);
    if (reason === 'session_expired') {
      toastErrorNotify('Økten din har utløpt. Logg inn på nytt.');
      sessionStorage.removeItem('logout_reason'); // clean up after showing
    }
  }, []);

  const handleClickShowPassword1 = () => {
    setValues({
      ...values,
      showPassword1: !values.showPassword1,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // Redirect MV admins to Microsoft Entra login instead of the normal OTP flow.
  const handleEntraRedirect = async () => {
    setEntraRedirecting(true);
    try {
      const response = await apiClient.get(MvAdminAuthorizeUrl);
      const authorizeUrl = response.data?.authorizeUrl;
      if (authorizeUrl) {
        window.location.href = authorizeUrl;
      } else {
        toastErrorNotify("Klarte ikke hente innloggingslenke. Prøv igjen.");
        setEntraRedirecting(false);
      }
    } catch (err) {
      toastErrorNotify("Klarte ikke koble til innloggingstjenesten.");
      setEntraRedirecting(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const data = new FormData(e.currentTarget);
    const email = data.get("email");
    const password = data.get("password1");

    const initialValues = {
      email,
      password1: password,
      password2: password,
    };

    try {
      await validationSchema.validate(initialValues, { abortEarly: false });
      const resultAction = await postOtp(initialValues);
      // console.log(resultAction,  "action")
      console.log(resultAction);
      if (resultAction.data?.statusCode === 200) {
        setOtpMenu(true);
        setEmail(email);
        successNote("Verifiseringskode sendes");
      }else {
         if (resultAction?.error?.status === 500) {
          toastErrorNotify("Server Error");
        // } 
         // else if (resultAction?.error.data?.data) {
         //  toastErrorNotify(resultAction?.error.data.data?.validationErrors[0]);
        }else if (resultAction?.error.data.data === null) {
          toastErrorNotify(resultAction?.error.data?.message);
        }else if (!resultAction.error) {
            toastErrorNotify("Ingen serverrespons");
        } else {
          toastErrorNotify("Innlogging Mislyktes");
        }
        // console.log(resultAction?.error);
      }
    } catch (err) {
      console.log('Error:', err);
      if (err instanceof Yup.ValidationError) {
        // This is a validation error
        err.inner.forEach((e) => {
          yupErrors[e.path] = e.message;
        });
        setValidationErrors(yupErrors);
      } 
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid
      container
      component="main"
      sx={{
        backgroundImage: `url(${authBackgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      
      <Container component="main" maxWidth="xs">
        {/*<Typography*/}
        {/*    component="h1"*/}
        {/*    variant="h4"*/}
        {/*    align="center"*/}
        {/*    marginTop={8}*/}
        {/*    display="flex"*/}
        {/*    // sx={{ fontFamily: "exo" }}*/}
        {/*>*/}
        {/*  /!*Dr. Cloud – Din plattform for VR-trening*!/*/}
        {/*</Typography>*/}
        
        <Box
          sx={{
            // marginTop: 4,
            backgroundColor: "rgba(255,255,255, 0.8)",
            p: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: 5,
          }}
        >
          {
            !siteOpen ? (
                <>
                  <img
                      src={logoRed}
                      alt="Logo"
                      style={{ width: 160, marginBottom: 16 }}
                  />
                  <Typography variant="h5" gutterBottom>
                    Planlagt nedetid
                  </Typography>
                  <Typography variant="body1" align="center" sx={{ mb: 2 }}>
                    Vi utfører planlagt vedlikehold for å legge til nye funksjoner, samt forbedre stabilitet og ytelse.
                  </Typography>
                  <Typography variant="body1" align="center" sx={{ mb: 3 }}>
                    Tjenesten vil være tilgjengelig igjen så snart arbeidet er fullført, planlagt:
                    <br />
                    <b>13:00 19.03.2026</b>.
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Takk for tålmodigheten din!
                  </Typography>
                </>
            ) : otpMenu ? (
              <OtpVerify email={email}/>
            ) : (
              <>
              <img src={logoRed} alt="Logo" className="logoLogin" />
          <Typography component="h1" variant="h5">
            Logg inn
          </Typography>
          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit}
            sx={{ mt: 3 }}
          >
            <Grid container spacing={2}>
              <Grid item sm={12}>
              <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="E-post "
                    name="email"
                    autoComplete="email"
                    autoFocus
                    error={Boolean(validationErrors.email)}
                    helperText={validationErrors.email}
                  />
              </Grid>
              <Grid item sm={12}>
              <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="password1"
                    label="Passord"
                    type={values.showPassword1 ? "text" : "password"}
                    id="password1"
                    error={Boolean(validationErrors.password1)}
                    helperText={validationErrors.password1}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword1}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {values.showPassword1 ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          }
                        </InputAdornment>
                      ),
                    }}
                  />
              </Grid>
            </Grid>
             {/* <Grid> 
                 <FormControlLabel
                 control={<Checkbox value="remember" color="primary" />}
                   label="Remember me"
               /> 
           </Grid>  */}
            <Button
              className="PrimaryButton"
              type="submit"
              fullWidth
              variant="contained"
              disabled={loading || entraRedirecting}
              sx={{ mt: 3, mb: 2 }}
            >
              {entraRedirecting
                ? <><CircularProgress size={20} sx={{ color: '#fff', mr: 1 }} /> Logger inn via Microsoft…</>
                : loading
                  ? <Loading color={"#fff"} size={25} />
                  : "Logg inn"}
            </Button>
                     <Grid item xs>
                      <Link href="/forgotpassword" variant="body2">
                       Glemt passord
                      </Link>
                    </Grid>
            <Copyright sx={{ mt: 1 }} />
          </Box>
              </>
            )
          }
        </Box>
      </Container>
    </Grid>
  );
}
